import { ReqBodyType } from './types/reqBody';
import HttpClient from './utils/HttpClient';

interface ILinesService {
  codUsu?: number;
  perfilUsu?: number;
  token: string;
  tipoAcao?: number;
  codOperadora?: number;
  reqBody?: ReqBodyType;
}

class LinesService {
  private readonly httpClient: HttpClient;
  constructor() {
    this.httpClient = new HttpClient(process.env.REACT_APP_PATHNAME ?? '');
  }

  listLines = async ({
    codUsu,
    perfilUsu,
    tipoAcao = 31,
    codOperadora = 0,
    token,
  }: ILinesService) => {
    return this.httpClient.get({
      token,
      path: `/api/SMob_CadLinhasTransporte?codUsu=${codUsu}&perfilUsu=${perfilUsu}&tipoAcao=${tipoAcao}&codOperadora=${codOperadora}`,
    });
  };

  createOrUpdateLine = async ({
    reqBody,
    token,
  }: ILinesService) => {
    return this.httpClient.post({
      token,
      path: '/api/SMob_CadLinhasTransporte',
      reqBody,
    });
  };

  removeLines = async ({
    reqBody,
    token,
  }: ILinesService) => {
    return this.httpClient.put({
      token,
      path: '/api/SMob_CadLinhasTransporte',
      reqBody,
    });
  };
}

export default new LinesService();
